// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAuction } from './Auction';
import type { ICalltracking } from './Calltracking';
import type { IMessagesWithSubscriptionModel } from '../PopupMessages/MessagesWithSubscriptionModel';
import type { IMultiposting } from './Multiposting';
import type { IServicePackagePeriod } from './ServicePackagePeriod';
import type { IPublishTerm } from './PublishTerm';
import type { IPublication } from './Publication';
import type { IRecommendedServicePackageV2 } from './RecommendedServicePackageV2';

export interface IGetPublishTermsResponseV2 {
  auction?: IAuction;
  /** Подключена ли автопролонгация к объявлению **/
  autoProlong: boolean;
  calltracking?: ICalltracking;
  /** Коэффициент, на к-ый умножены цены (если применён эксперимент дифференцирования цены) **/
  highDemandCoefficient?: number;
  /** Эксперимент дифференцирования цены "Высокий спрос" **/
  isHighDemand: boolean;
  /** Разрешен ли мультипостинг **/
  isMultipostingAvailable: boolean;
  message?: IMessagesWithSubscriptionModel;
  multiposting?: IMultiposting;
  /** Доступные пакеты для публикации объявления с выбранной услугой. **/
  servicePackages?: IServicePackagePeriod[];
  /** URL страницы обратной связи **/
  supportUrl?: string;
  /** Основные тарифы **/
  terms?: IPublishTerm[];
  publication?: IPublication;
  /** Информация о рекомендуемых пакетах при подаче объявления на ФВУ **/
  recommendedServicePackages?: IRecommendedServicePackageV2[];
  /** ФВУ без минимальных ставок, если пользователь попал в эксперимент **/
  withoutMinimalBet: boolean;
  /** Источник средств **/
  moneySource?: EMoneySource;
  /** Доступные варианты списания **/
  availableMoneySources: EAvailableMoneySources;
  /** Если разрешена публикация за счёт пакета. **/
  isAllowPackage: boolean;
}
export enum EMoneySource {
  /** Собственные средства **/
  'Self' = 'self',
  /** Средства агентства **/
  'Master' = 'master',
}
export enum EAvailableMoneySources {
  /** Доступно списание только со своего счета **/
  'Self' = 'self',
  /** Доступно списание только со счет а мастера **/
  'Master' = 'master',
  /** Доступно списание только и со счета мастера, и со своего **/
  'MasterAndSelf' = 'masterAndSelf',
}
